import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div``;

export const Header = styled.div`
    text-align: start;
`;

export const Body = styled.div`
    background-color: ${theme.colors.primaryWhite};
`;

export const Results = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;

    @media ${getBreakpoint("up", "lg")} {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-top: 0;
    }

    @media ${getBreakpoint("down", "sm")} {
        & > *:not(:first-child):not(:last-child) {
            padding-left: ${theme.space[2]}px;
            padding-right: ${theme.space[2]}px;
        }
    }
`;
